import styled from 'styled-components';

const StyledHeroProducts = styled.div`
  position: relative;
  margin-right: 16px;
  margin-left: 16px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  overflow: hidden;
  .industries--hero-bg{
    position: absolute;
    top: 16px;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px; 
    width: 100%;
    height: 100%;
    background-color: #000;
  }
  h4{
    position: relative;
    text-align: center;
    color:#fff;
    margin: 0 auto;
    max-width: 50%;
    z-index: 2;
  }
  img{
    position: absolute;
    width: 41.65%;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
  img.left{
    left: -16.66%;
  }
  img.right{
    right: -16.66%;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .industries--hero-bg{
      margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    }
    
  }
  @media screen and (max-width: 767px){
    margin-right: 8px;
    margin-left: 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .industries--hero-bg{
      top: 8px;
      margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    }
    h4{
      padding: 0 16px;
      max-width: 100%;
      top: 0;
      transform: translateY(-50%);
    }
    img{
      top: auto;
      bottom: 40px;
      width: 100%;
      transform: translateY(0);
    }
    img.left{
      left: -50%;
    }
    img.right{
      right: -50%;
    }
  }
`;

export {
  StyledHeroProducts,
};

